import { SvgIcon } from "@mui/material";
import CheckGPTLogoSvg from "jsx:../../../Images/Icons/Custom/checkgpt_logo.svg";

export function CheckGPTLogoIcon() {
    return (
        <SvgIcon
            component={CheckGPTLogoSvg}
            inheritViewBox
            sx={{ width: 32, height: 32 }}
        />
    );
}
